/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const LOADER_STATUS = 'boilderplate/UploadPage/LOADER_STATUS';
export const PROFILE_INFO = 'boilerplate/UploadPage/PROFILE_INFO';
export const ON_GSTR_SUMMARY = 'boilerplate/UploadPage/ON_GSTR_SUMMARY';
export const ON_GSTR_SUMMARY_AMD = 'boilerplate/UploadPage/ON_GSTR_SUMMARY_AMD';
export const SET_NIL_DATA = 'boilerplate/UploadPage/SET_NIL_DATA';
export const SET_DOC_ISSUE_DATA = 'boilerplate/UploadPage/SET_DOC_ISSUE_DATA';
export const SET_HSN_DATA = 'boilerplate/UploadPage/SET_HSN_DATA';

